import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "\"I’m a ocean of failure... so I swim\"",
  "description": "",
  "published": "2019-11-21T00:00:00.000Z",
  "redirect_from": ["/blog/im-a-ocean-of-failure-so-i-swim/swizec/9241"],
  "categories": "Personal",
  "hero": "./img/techletter.app-screenshot-1574355063175.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Do you know that game, abysmall failure at life and everything or hungry? It's a fun game, I play it often.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1197206705743859712"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "48.4304932735426%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'193\\'%20viewBox=\\'0%200%20400%20193\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-5%203-7%208-7%2014l2%206%201%202c0%201%206%205%2010%206%203%200%205%200%208-2%206-2%206-4%202-4-3%200-4-3-1-5%201-1%203-2%204-1l1-1%202-1%201-2c0-10-14-18-23-12m102%20113c-3%203-3%207%200%2010%203%204%205%204%204%200s-1-7%201-8c1%200%203%202%203%205%201%205%201%205%202%204%203-2%203-6%202-9-3-5-8-5-12-2m20-1c-7%204-4%2013%204%2013%205%200%207-2%207-7s-6-8-11-6m17%202c-5%205-2%2012%205%2012s10-8%205-13c-4-3-7-3-10%201m37-1c-2%201-3%203-3%205%200%205%201%206%205%205%204%200%206%201%202%202-1%201-1%201%201%201l4-2c7-7-2-17-9-11m37-1c-4%202-5%2011-1%2011v-4l2%202c3%203%206%202%206-2%200-2%200-2%201-1v3l1%201c3%200%202-6%200-9-3-2-5-2-9-1m-20%202c-4%204-1%2012%206%2012%205%200%209-9%205-13-2-2-9-1-11%201m-28%201c0%202-1%202-5%202s-5%200-5%202c0%206%207%209%2012%205%202-1%203-7%201-7l-2-2c-1-2-1-2-1%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/007f19a014d6d121332f4cddec568a11/ca0a1/techletter.app-screenshot-1574355063175.webp 223w", "/static/007f19a014d6d121332f4cddec568a11/75680/techletter.app-screenshot-1574355063175.webp 445w", "/static/007f19a014d6d121332f4cddec568a11/0ba47/techletter.app-screenshot-1574355063175.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/007f19a014d6d121332f4cddec568a11/e92b6/techletter.app-screenshot-1574355063175.png 223w", "/static/007f19a014d6d121332f4cddec568a11/e66bf/techletter.app-screenshot-1574355063175.png 445w", "/static/007f19a014d6d121332f4cddec568a11/6af66/techletter.app-screenshot-1574355063175.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/007f19a014d6d121332f4cddec568a11/6af66/techletter.app-screenshot-1574355063175.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`To be honest, I don't know where it comes from. Maybe it's like being hangry – you lack energy so your emotions run wild. Whatever they are.`}</p>
    <p>{`For me it likes to sneak up when I look at past achievements that I was so proud to achieve and think `}<em parentName="p">{`"You could've done better and you know it`}</em>{`. I could've, but I didn't. I am where I am.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=Q9WZtxRWieM"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M249%202l-2%203c-2%202-1%207%201%209%201%201%200%2016-1%2019l-1%207-5%2020a170%20170%200%2000-5%2032l-1%204c1%204-1%207-3%207l-1%203-2%204-5%206c-2%204-4%205-6%206l-6%203c-3%203-3%203-3%208s1%205%204%206h12l24-2c20-1%2023-2%2023-7%200-3%200-4%204-5%203-2%204-3%202-7-1-3-1-3%201-6l3-7%201-26c0-6%201-9%203-9s1-4-1-4l-1-7a279%20279%200%20002-45l2-4-2-2c-2-1-2-2-2-5l1-3h-18c-17%200-18%200-18%202m98-1l1%203c-1%201%200%202%201%204s2%204%201%205l1%204c2%203%202%2016%200%2025a388%20388%200%2000-5%2023c0%205-4%2016-5%2016l-1%205c1%204%201%204-1%205-1%200-2%201-2%204%200%204-1%204-5%203-4-2-8%200-14%206l-7%206h10c13%200%2019%201%2022%206l4%203%205%205%207%208c4%204%203%2017-2%2023l-1%202%206-1%204-2c0-1%201-3%203-3%202-1%203-2%204-5%200-2%201-3%202-3%203%202%205%200%208-7l8-11c4-3%205-5%205-8%200-9%202-8%202%201l-2%2014-1%2010c0%206%200%207-4%2010-3%203-4%203-5%202h-3l-3%202c-2%200-3%205-1%208l1%206v15l-1%2011c-1%200-2%201-2%203-1%202-1%202-4%202-2-1-3-1-7%203s-5%205-13%206l-7%202%207%201c6%201-2%201-43%201a661%20661%200%2000-28%202c17%200%2023%201%2024%202s-5%201-30%201l-32-1c1-3-3-3-53-4-33%200-49%200-48-1v-14l-3-1-4%201-3%2013c0%202-1%202-6%202s-7%201-9%202c-2%202-3%202-5%201h-4c-2%202-4%202-25%202l-24%201h-7l-1-2h-1c-2-1-2-1-2%201s-1%202-3%202c-3%200-4-1-4-2s1-2%202-1l1-1-5-1c-3%200-4%200-3%202%200%203-2%205-5%203-2-2-1-2%202-4l2-1-4-1-17-1c-10%200-12%200-11-1l54-1c47%200%2051%200%2051-2l-11-1c-14%201-24%201-26-1l-10-1a47%2047%200%2001-22-6c-3%200-7-2-7-4%201-2-1-6-3-6l-1-2-2-4c-1-1-1-1%201-3l1-2%201-1c2-1%202%207%200%209l1%201c1-1%202%200%202%201%201%202%203%201%202-2-1-4-1-11%201-11l2%203c1%206%204%208%204%203%200-2%200-2%203-2%202%201%202%201%202-1l-1-3-1-2c0-2%204-2%206%200%203%202%206-1%204-3-3-3-2-4%201-6l3-1%202%204c3%206%208%2010%2015%2012%206%200%206%200%202-3-6-3-16-18-12-18l1%201c0%201%202%203%204%203%205%202%2012%202%2011%201l-3-1c-2%200-3%200-4-2l-2-2h-5l2-1%203-1h1c1-1%202%200%204%201l3%203%204%203%206%203%209%205c2%203%204%204%205%204l-1-3c-2-1-2-1%200-3%201-2%202-2%202%201%201%203%201%203%202%201%200-2%201-2%203-2%203%201%203%201%203-4l3-8%203-5%202-5c3-7%202-11-2-17l-4-6c0-2-4-5-5-5l-2-1c-2-1-2-1%201-1h3l-6-5c-11-11-11-11-11-15%200-5%202-7%2010-8%206-1%2016-6%2015-7v-5l-1-6V55l-2-5-3-4c-2-3-3-9-2-10l7-1c9-1%2011-2%207-4l-4-1c-1%202-3%200-3-2%201-3-4-6-6-4-1%201-1%201%201%201%203%200%205%204%202%205-1%201-3%200-9-3-7-2-9-3-12-2-3%200-3%200-2-1l-1-1h-2c-1-2-11%209-12%2012-2%204-7%206-10%206-7%200-10%202-10%207v8c0%204%200%205-2%206l-3%205-7%2014-1%204-3%207-3%205-3%2011-2%209-1%203-2%206-4%209c-4%207-4%2023%200%2023l1%201-4%201c-4%200-5%200-6-2%200-2-1-3-3-4l-2-1h2c3-1%204-3%202-3s-3%200-3-2l-1-2v-7c2-2%201-5-4-10l-5-5v-5c1-5%201-6-2-7l-3-1v114h401v-55a686%20686%200%2000-2-85l1-44V0h-27c-24%200-27%200-26%201M152%2044l-5%201c-4%200-8%202-8%204l-2%204c-2%203-2%205%201%205v-1l1-1%203%201%201%203v2l-2-2-2-1%202%202%201%202c0%202%202%203%206%204l2-1c-1-1%200-2%201-2l1-1c0-3-2-7-3-7l-2-1-4-2-3-1%203-1c5-2%208-2%207%201-1%201%200%201%206%201%206-1%207-1%209%201%201%202%204%203%204%201%200-1-5-5-7-5s-3-2-1-2c1-1%200-1-1-2-2%200-2%200%202-2l5-1h-8l-7%201m38%2063v12l19-1v-12c-2-2-17-1-19%201m-41%2069c-4%203-12%2016-12%2018l4%201c3-1%203-1%205-6l5-11c4-7%204-7-2-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0917c353672b01039531363ccdc980d7/ca0a1/techletter.app-screenshot-1574355078936.webp 223w", "/static/0917c353672b01039531363ccdc980d7/75680/techletter.app-screenshot-1574355078936.webp 445w", "/static/0917c353672b01039531363ccdc980d7/0ba47/techletter.app-screenshot-1574355078936.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0917c353672b01039531363ccdc980d7/e92b6/techletter.app-screenshot-1574355078936.png 223w", "/static/0917c353672b01039531363ccdc980d7/e66bf/techletter.app-screenshot-1574355078936.png 445w", "/static/0917c353672b01039531363ccdc980d7/6af66/techletter.app-screenshot-1574355078936.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0917c353672b01039531363ccdc980d7/6af66/techletter.app-screenshot-1574355078936.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Note to self: Do not look at metrics when you're hungry. Keep forgetting that one 😅`}</p>
    <p>{`More importantly, folks on twitter shared so many wonderful tips to shake that feeling of failure we all feel sometimes that I wanted to share my favs with you. You should `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1197206705743859712"
      }}>{`read the whole thread, too`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/LuizAdolphs/status/1197207999212924933"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.2914798206278%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'181\\'%20viewBox=\\'0%200%20400%20181\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M33%208c-2%201-2%202-1%202l1%203c0%201%201%202%204%202%205%200%2011%205%207%206-3%200-2%204%201%204l2%201h-5l-5%201-2%201c-3-1-4%200-5%204l4%203c10%204%2021-4%2019-14%200-4-1-4-3-4l-2-1-1-3v-1c2%200%201-2-3-3-4-2-9-2-11-1m101%20115c-4%203-4%208%201%2011%203%202%206%202%209-1%202-2%203-8%201-8l-4-2c-3-4-4-4-7%200m19-2c-4%202-5%208-2%2011%204%206%2013%203%2013-4%200-6-6-9-11-7m36%201c-2%202-3%203-3%205%200%203%200%203%202%202%201-2%201-2%201%200s1%203%202%203l3%201c2%201%202%201%204-1%203-3%203-7%200-10-4-3-6-3-9%200m72%200c-5%205-2%2013%205%2013%204%200%206-2%204-3-1-1-1-3%202-3%202%200%201-5-2-7-3-3-6-3-9%200m-53%201l-1%201c0-2-3%202-3%204%200%205%206%209%207%206h2c1%202%206-3%206-6%200-6-9-10-11-5m-34%200l-1%203c0%202-1%203-3%204s-2%201%200%203c1%202%206%203%209%201%202-1%203-3%201-3-1%200-2-1-2-3v-2l2%202c1%204%202%204%202%200%200-3%200-3-2-3-1%201-1%200-2-1%200-2-3-3-4-1m70%200v4c1%202%201%202-1%203l-2%201%202%202c4%204%2012%201%2012-4%200-2-3-5-5-4l-1-1c0-2-3-3-5-1m36%202c1%201%200%202-1%202-3%200-3%204%200%206%202%203%208%202%2010%200%203-2%203-6%202-8-2-1-4%200-4%202v1l-2-3c-1-4-6-4-5%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0647e6a64438f647c0ec5dc972644c0e/ca0a1/techletter.app-screenshot-1574355062882.webp 223w", "/static/0647e6a64438f647c0ec5dc972644c0e/75680/techletter.app-screenshot-1574355062882.webp 445w", "/static/0647e6a64438f647c0ec5dc972644c0e/0ba47/techletter.app-screenshot-1574355062882.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0647e6a64438f647c0ec5dc972644c0e/e92b6/techletter.app-screenshot-1574355062882.png 223w", "/static/0647e6a64438f647c0ec5dc972644c0e/e66bf/techletter.app-screenshot-1574355062882.png 445w", "/static/0647e6a64438f647c0ec5dc972644c0e/6af66/techletter.app-screenshot-1574355062882.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0647e6a64438f647c0ec5dc972644c0e/6af66/techletter.app-screenshot-1574355062882.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/dabit3/status/1197239118918492160"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "65.47085201793722%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'261\\'%20viewBox=\\'0%200%20400%20261\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M47%2011c0%202-1%202-3%201s-3%200-5%201h-5c-3-1-7%201-7%204l-1%201c-2-2-1%200%201%203l2%202-2%202c-3%202-2%205%203%209%207%205%2017%203%2022-5%203-5%203-5-1-5l-2-3v-4l-1-4-1-2m49%20191c-3%203-3%207%200%2010l2%201h4l-2%201h-2l2%201h5c2-2%203-3%200-3-1%200-1-1%201-2%204-3%204-4%200-8-3-3-6-3-10%200m20-1c-7%204-4%2014%204%2014%207%200%2010-9%204-13-3-2-3-2-8-1m19%200c-3%201-4%203-3%207v3c-1%202%202%204%205%204%205%200%208-2%206-4l-1-5c1-4%200-4-2-5l-2-1-3%201m17%201c-4%203-4%2011%200%2011l1%201%204%201%203-1%201-1c4-2%203-8-1-11-3-3-5-2-8%200m19%200c-2%202-2%202%200%204%202%201%202%201%201%203-2%204-1%206%203%206%203%200%206-2%206-6%201-6-6-11-10-7m37-1l-1%207%201%206c1%202%206%201%206%200l1-2%202-1h-2c-2%201-2%201-2-1l1-4%202-1%201-1c-1-2-6-4-9-3m-16%201v5l-3%201c-1%200-2%200-2-2l-1%201c-3%206%207%2011%2012%206%202-3%202-6%200-6l-2-2c0-3-3-5-4-3m32%201c-3%202-2%208%200%2010%202%203%208%202%2010%200%203-2%202-8%200-10s-8-2-10%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ab4bf890220fdca7d2eb31c02a202c19/ca0a1/techletter.app-screenshot-1574355063011.webp 223w", "/static/ab4bf890220fdca7d2eb31c02a202c19/75680/techletter.app-screenshot-1574355063011.webp 445w", "/static/ab4bf890220fdca7d2eb31c02a202c19/0ba47/techletter.app-screenshot-1574355063011.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ab4bf890220fdca7d2eb31c02a202c19/e92b6/techletter.app-screenshot-1574355063011.png 223w", "/static/ab4bf890220fdca7d2eb31c02a202c19/e66bf/techletter.app-screenshot-1574355063011.png 445w", "/static/ab4bf890220fdca7d2eb31c02a202c19/6af66/techletter.app-screenshot-1574355063011.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ab4bf890220fdca7d2eb31c02a202c19/6af66/techletter.app-screenshot-1574355063011.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/brianball/status/1197215949490778112"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.33632286995517%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'302\\'%20viewBox=\\'0%200%20400%20302\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%209c-14%206-8%2029%208%2028%207-1%2010-3%2012-9%205-14-7-25-20-19m42%20234c-2%201-3%205-1%205%201%200%202%201%201%202l-2%201c-2%200-2%200-1%202%201%201%203%202%204%201l1%201h5c2-1%202-2%201-3l-1-5c0-6-3-7-7-4m16%200c-3%203-3%208%200%2011%207%206%2017-4%2011-11-4-3-8-3-11%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a5c627b5a9f733d67d5b390060eb561f/ca0a1/techletter.app-screenshot-1574355062927.webp 223w", "/static/a5c627b5a9f733d67d5b390060eb561f/75680/techletter.app-screenshot-1574355062927.webp 445w", "/static/a5c627b5a9f733d67d5b390060eb561f/0ba47/techletter.app-screenshot-1574355062927.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a5c627b5a9f733d67d5b390060eb561f/e92b6/techletter.app-screenshot-1574355062927.png 223w", "/static/a5c627b5a9f733d67d5b390060eb561f/e66bf/techletter.app-screenshot-1574355062927.png 445w", "/static/a5c627b5a9f733d67d5b390060eb561f/6af66/techletter.app-screenshot-1574355062927.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a5c627b5a9f733d67d5b390060eb561f/6af66/techletter.app-screenshot-1574355062927.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/levelsio/status/1197229677451988992"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.2914798206278%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'181\\'%20viewBox=\\'0%200%20400%20181\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M34%207c-10%204-13%2017-6%2025%204%204%2016%205%2017%202%201-7%201-8%202-6l3%202v-1h1l1-1v-1c3%202%203-8-1-13-3-7-11-10-17-7m45%20115c-4%204-4%208-1%2011%204%203%204%203%203-1v-3l2%201%202%204c0%202%202%201%204-2%206-7-4-16-10-10m17%200c-2%203-3%208-1%2010h3c0-2%201-2%202-1%202%201%205%200%205-3h1v2l1%201c3%200%202-7-1-9-3-3-7-3-10%200m20%200c-4%202-4%203-4%206%201%207%208%209%2013%205%206-7-2-16-9-11m19-1c-2%201-2%203-2%208l1%206h4c5%200%206-1%206-7%200-7-5-10-9-7m52%201l-2%205h1c2-3%203-2%203%201l-1%203-1-1-1-1c-2%200-1%202%201%204s8%203%2010%201c3-2%203-7%201-8v-1c1-1%201-1-1-3-3-3-7-3-10%200m21-1v2c2%200%203%206%201%206-1%200-2-2-2-5s-1-2-3%201c-2%205%201%2010%207%209%207%200%209-6%204-11-3-3-5-4-7-2m18%200v1l-1%201c0-1-2%200-3%202v4c2%200%202%201%201%201-3%201%202%205%206%205h3l-3-2c-3-3-3-5%200-5l2-1%201-2%201%203c0%202%200%202-1%201s-1-1-1%201c0%204%204%202%205-2%200-5-5-9-10-7m-74%202c-4%202-5%207-1%207%202%200%202%200%201%202-2%201-1%203%203%203%203%201%208-2%206-4-1-1-1-1%201-1%203-1%203-4-1-4-2%200-2%200-2-2%201-3-3-4-7-1m16%201c-4%207%202%2013%209%2010%203-1%203-1%202-2v-1c1%201%202%200%202-1l-1-1-1-2c0-2-2-3-3-1-1%201-5-1-5-3s-2-1-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/de3174213278acd928b83f4795f5f699/ca0a1/techletter.app-screenshot-1574355063106.webp 223w", "/static/de3174213278acd928b83f4795f5f699/75680/techletter.app-screenshot-1574355063106.webp 445w", "/static/de3174213278acd928b83f4795f5f699/0ba47/techletter.app-screenshot-1574355063106.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/de3174213278acd928b83f4795f5f699/e92b6/techletter.app-screenshot-1574355063106.png 223w", "/static/de3174213278acd928b83f4795f5f699/e66bf/techletter.app-screenshot-1574355063106.png 445w", "/static/de3174213278acd928b83f4795f5f699/6af66/techletter.app-screenshot-1574355063106.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/de3174213278acd928b83f4795f5f699/6af66/techletter.app-screenshot-1574355063106.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/serapath/status/1197538391052697601"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "76.23318385650224%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'306\\'%20viewBox=\\'0%200%20400%20306\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M141%208v7l1%206h13V7h-6l-8%201M40%2013c0%204-1%205-5%205l-3%201%201%201c2-1%202%200%202%201l-1%203v7l2%206h5c5-1%206-1%204-4-1-3-1-5%201-7v-2c-1-1%200-7%202-8s-1-5-5-6c-3%200-3%200-3%203M27%20151l-2%205c0%208%2010%208%2011%200%200-6-5-9-9-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7ecc93ee98befd4078d1c73a5733bab0/ca0a1/techletter.app-screenshot-1574355063177.webp 223w", "/static/7ecc93ee98befd4078d1c73a5733bab0/75680/techletter.app-screenshot-1574355063177.webp 445w", "/static/7ecc93ee98befd4078d1c73a5733bab0/0ba47/techletter.app-screenshot-1574355063177.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7ecc93ee98befd4078d1c73a5733bab0/e92b6/techletter.app-screenshot-1574355063177.png 223w", "/static/7ecc93ee98befd4078d1c73a5733bab0/e66bf/techletter.app-screenshot-1574355063177.png 445w", "/static/7ecc93ee98befd4078d1c73a5733bab0/6af66/techletter.app-screenshot-1574355063177.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7ecc93ee98befd4078d1c73a5733bab0/6af66/techletter.app-screenshot-1574355063177.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/_AshConnolly/status/1197247570654965760"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "55.60538116591929%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'223\\'%20viewBox=\\'0%200%20400%20223\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%209c-10%206-9%2021%201%2026%2013%206%2027-8%2020-20-4-7-14-10-21-6m60%20155c-4%203-4%2013%200%2011h3l-1%201c-1%201-1%201%202%201%204%200%207-2%204-3-2%200-1-2%202-3s2-4-1-7-6-2-9%200m-18%200c-2%201-2%201-1%205%202%208%207%2010%2010%203%202-6-2-11-9-8\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c48166a21c2cf93e2ca1df1b997abd71/ca0a1/techletter.app-screenshot-1574355062913.webp 223w", "/static/c48166a21c2cf93e2ca1df1b997abd71/75680/techletter.app-screenshot-1574355062913.webp 445w", "/static/c48166a21c2cf93e2ca1df1b997abd71/0ba47/techletter.app-screenshot-1574355062913.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c48166a21c2cf93e2ca1df1b997abd71/e92b6/techletter.app-screenshot-1574355062913.png 223w", "/static/c48166a21c2cf93e2ca1df1b997abd71/e66bf/techletter.app-screenshot-1574355062913.png 445w", "/static/c48166a21c2cf93e2ca1df1b997abd71/6af66/techletter.app-screenshot-1574355062913.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c48166a21c2cf93e2ca1df1b997abd71/6af66/techletter.app-screenshot-1574355062913.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/petecodes/status/1197259647482245126"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "65.47085201793722%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'261\\'%20viewBox=\\'0%200%20400%20261\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M33%208l-1%202v2c0%203-2%202-2%200%202-4-2-1-4%203-4%208-2%2010%208%207h5c1%201%202%200%203-4%202-6%207%200%206%206-1%202-1%203%201%203l1%203c-2%203%201%201%203-2%205-13-9-26-20-20m-3%2018l-4%203c0%203%208%208%2013%208l4-1c2%200%201-2-2-2-2-1-3-2-3-4-2-5-3-6-8-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/16d973fd7e1eb9a9e021722f45b76c85/ca0a1/techletter.app-screenshot-1574355063097.webp 223w", "/static/16d973fd7e1eb9a9e021722f45b76c85/75680/techletter.app-screenshot-1574355063097.webp 445w", "/static/16d973fd7e1eb9a9e021722f45b76c85/0ba47/techletter.app-screenshot-1574355063097.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/16d973fd7e1eb9a9e021722f45b76c85/e92b6/techletter.app-screenshot-1574355063097.png 223w", "/static/16d973fd7e1eb9a9e021722f45b76c85/e66bf/techletter.app-screenshot-1574355063097.png 445w", "/static/16d973fd7e1eb9a9e021722f45b76c85/6af66/techletter.app-screenshot-1574355063097.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/16d973fd7e1eb9a9e021722f45b76c85/6af66/techletter.app-screenshot-1574355063097.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/ljayham/status/1197210492940496903"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50.224215246636774%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'201\\'%20viewBox=\\'0%200%20400%20201\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%209c-9%205-9%2019-1%2025%204%203%2013%203%2017%200%208-5%209-19%201-24-4-3-13-3-17-1m43%20133c-2%202-2%202-1%205v7c2%202%206%201%208-1l1-2h-2c-1%200%200-5%202-6s1-2-2-3c-4-2-3-2-6%200m34%200c-2%203-3%208-1%2010h2l3%201v1h-2l2%201h4c3-1%203-1%202-3-3-1-2-2%201-3s3-3-1-7c-3-3-6-3-10%200m-19%203v5c-2%201%203%205%206%205%205%200%209-4%207-6l-2-3c-1-3-10-4-11-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8776498829c79ac6d2b455551ba732e2/ca0a1/techletter.app-screenshot-1574355062786.webp 223w", "/static/8776498829c79ac6d2b455551ba732e2/75680/techletter.app-screenshot-1574355062786.webp 445w", "/static/8776498829c79ac6d2b455551ba732e2/0ba47/techletter.app-screenshot-1574355062786.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8776498829c79ac6d2b455551ba732e2/e92b6/techletter.app-screenshot-1574355062786.png 223w", "/static/8776498829c79ac6d2b455551ba732e2/e66bf/techletter.app-screenshot-1574355062786.png 445w", "/static/8776498829c79ac6d2b455551ba732e2/6af66/techletter.app-screenshot-1574355062786.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/8776498829c79ac6d2b455551ba732e2/6af66/techletter.app-screenshot-1574355062786.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/sachinpc/status/1197252395933126656"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.2914798206278%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'181\\'%20viewBox=\\'0%200%20400%20181\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%208l-2%202-3%205c-2%202-3%205-3%207%200%204%202%204%203%200l2-4c1-2%201-2%204%200l2%203-2%205c-3%209%203%2014%2012%209%2011-5%2011-20%202-26-4-2-11-3-15-1m59%20114c-5%204-3%2012%202%2011%202%200%202%200%201%201-2%201-2%201%200%201%202%201%206-1%206-2l-1-1c-2%200-1-2%202-3s3-3-1-7c-3-3-6-3-9%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b85001383ac4fd0a76e0ff589f96583c/ca0a1/techletter.app-screenshot-1574355062828.webp 223w", "/static/b85001383ac4fd0a76e0ff589f96583c/75680/techletter.app-screenshot-1574355062828.webp 445w", "/static/b85001383ac4fd0a76e0ff589f96583c/0ba47/techletter.app-screenshot-1574355062828.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b85001383ac4fd0a76e0ff589f96583c/e92b6/techletter.app-screenshot-1574355062828.png 223w", "/static/b85001383ac4fd0a76e0ff589f96583c/e66bf/techletter.app-screenshot-1574355062828.png 445w", "/static/b85001383ac4fd0a76e0ff589f96583c/6af66/techletter.app-screenshot-1574355062828.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/b85001383ac4fd0a76e0ff589f96583c/6af66/techletter.app-screenshot-1574355062828.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/superpatell/status/1197300535805784065"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "55.15695067264574%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'221\\'%20viewBox=\\'0%200%20400%20221\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M34%209c-8%202-11%208-4%208l4%201v9l-1%206c-1%203%200%203%203%202%202-1%203-1%203%201l1%201c2%200%203-3%203-9s0-7%203-8l2-4v-1c2%201%203%200%202-2%200-2-6-5-7-4l-1-1c0-1-4-1-8%201m36%20152c-5%203-6%207-3%2011l2%201h4l-2%201h-2l2%201h5c2-1%203-3%200-3-1%200-1-1%201-2%204-3%204-4%200-8-3-2-4-3-7-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0de64bb5eaac0c2e41c4c38c0f672ed2/ca0a1/techletter.app-screenshot-1574355063642.webp 223w", "/static/0de64bb5eaac0c2e41c4c38c0f672ed2/75680/techletter.app-screenshot-1574355063642.webp 445w", "/static/0de64bb5eaac0c2e41c4c38c0f672ed2/0ba47/techletter.app-screenshot-1574355063642.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0de64bb5eaac0c2e41c4c38c0f672ed2/e92b6/techletter.app-screenshot-1574355063642.png 223w", "/static/0de64bb5eaac0c2e41c4c38c0f672ed2/e66bf/techletter.app-screenshot-1574355063642.png 445w", "/static/0de64bb5eaac0c2e41c4c38c0f672ed2/6af66/techletter.app-screenshot-1574355063642.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0de64bb5eaac0c2e41c4c38c0f672ed2/6af66/techletter.app-screenshot-1574355063642.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/MaximeHeckel/status/1197208309805154304"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.0896860986547%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'241\\'%20viewBox=\\'0%200%20400%20241\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%209c-8%206-9%2020-1%2025%2010%207%2023%200%2023-12S41%203%2031%209m39%20172c-5%203-6%207-3%2011l2%201h4l-2%201h-2l2%201h5c2-1%203-3%200-3-1%200-1-1%201-2%204-3%204-4%200-8-3-2-4-3-7-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b938e9d68105ad5c21008d18a4b453ea/ca0a1/techletter.app-screenshot-1574355062911.webp 223w", "/static/b938e9d68105ad5c21008d18a4b453ea/75680/techletter.app-screenshot-1574355062911.webp 445w", "/static/b938e9d68105ad5c21008d18a4b453ea/0ba47/techletter.app-screenshot-1574355062911.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b938e9d68105ad5c21008d18a4b453ea/e92b6/techletter.app-screenshot-1574355062911.png 223w", "/static/b938e9d68105ad5c21008d18a4b453ea/e66bf/techletter.app-screenshot-1574355062911.png 445w", "/static/b938e9d68105ad5c21008d18a4b453ea/6af66/techletter.app-screenshot-1574355062911.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/b938e9d68105ad5c21008d18a4b453ea/6af66/techletter.app-screenshot-1574355062911.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/GroundControl/status/1197271855658352646"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.51121076233184%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'331\\'%20viewBox=\\'0%200%20400%20331\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M34%2011c-4%203-5%204-4%2012%200%206%200%207-2%207s-1%202%202%204c3%203%206%203%2010%202%203-1%205-4%202-4-2%200-3-1-2-4l1-2v2c1%202%203%203%203%200%200-2-2-4-4-3-2%200-2%200-2-3%200-2%200-2%202%200%201%201%201%201%203-1s2-2%202%200%202%204%202%202c1-3-1-9-4-12s-5-3-9%200m86%2080c-4%205-1%2010%204%2010%207-1%207-11%200-12-2%200-3%200-4%202m-74%2062c-5%200-6%200-6%202l-1%203v-3c0-2-1-2-5-2-7%200-10%203-10%209%200%204%201%205%203%202%204-4%2014-5%2020-2%203%201%203%201%202%202l-13%2012-12%2010v20c0%2019%200%2019%202%2022l3%202h73v-28h-5c-6%200-7-2-4-6%204-4%204-3%200-6-5-2-5-4-1-7%203-4%203-10%200-12-2-2-2-2%200-8%203-11%205-10-17-10a426%20426%200%2001-29%200m36%2018c-5%204-3%2012%203%2012%203%200%208-3%207-5s-4-1-6%201h-1c0-2%203-4%205-4%201%201%202%200%202-1l-1-1-2-1c0-2-2-3-4-3l-3%202m-28%202c-2%201-2%202-1%202%202%202-1%204-3%203l-4%202c-3%202-3%203%200%203%202%200%202%200%202%202l-2%204c0%204-4%204-7%201l-3-2-3%203c-3%204-3%204-1%205s10%202%2013%201c1-1%202-1%202%201%203%209%2015%2013%2025%208l10-3c8%200%208%200%206-8%200-4-1-4-4-4s-3-1-4-4c-2-8-11-14-19-13-3%201-3%201-4-1%200-2-1-3-3%200m0%209c-3%204-4%205-4%209%200%2012%2014%2018%2023%2010%208-9%203-21-9-23-5%200-5%200-10%204m19%2089c-4%202-4%2013%200%2011%202%200%202%200%201%201v1h7v-2c-1-1-1-1%201-3%206-4-2-11-9-8\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8f89081f089d8c55bac038c2bd7bc9de/ca0a1/techletter.app-screenshot-1574355062906.webp 223w", "/static/8f89081f089d8c55bac038c2bd7bc9de/75680/techletter.app-screenshot-1574355062906.webp 445w", "/static/8f89081f089d8c55bac038c2bd7bc9de/0ba47/techletter.app-screenshot-1574355062906.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8f89081f089d8c55bac038c2bd7bc9de/e92b6/techletter.app-screenshot-1574355062906.png 223w", "/static/8f89081f089d8c55bac038c2bd7bc9de/e66bf/techletter.app-screenshot-1574355062906.png 445w", "/static/8f89081f089d8c55bac038c2bd7bc9de/6af66/techletter.app-screenshot-1574355062906.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/8f89081f089d8c55bac038c2bd7bc9de/6af66/techletter.app-screenshot-1574355062906.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`In a nutshell:`}</p>
    <ul>
      <li parentName="ul">{`accept yourself`}</li>
      <li parentName="ul">{`remove toxic influence`}</li>
      <li parentName="ul">{`mind the wins`}</li>
    </ul>
    <p>{`And remember, I love and accept you for who you are ❤️`}</p>
    <p>{`Happy Thursday,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: removing toxic influence `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1197255649593188352"
      }}>{`only goes so far 😅`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      